import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { Router } from "@angular/router";
import { from, Subject } from "rxjs";
import { concatMap } from "rxjs/operators";
import { FileService } from "../services/file-service";
import { HttpEventType } from "@angular/common/http";

export interface DialogData {
  animal: string;
  name: string;
}

@Component({
  selector: "app-file-upload-modal",
  templateUrl: "./file-upload-modal.component.html",
  styleUrls: ["./file-upload-modal.component.css"],
})
export class FileUploadModalComponent implements OnInit {
  showLoading = false;

  private files: FileList;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<FileUploadModalComponent>,
    private router: Router,
    private fileService: FileService
  ) {}

  ngOnInit() {}

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) {
      return;
    }

    const maxSize = 10 * 1024 * 1024;
    const files = Array.from(input.files);

    const invalidFiles = files.filter((file) => file.size > maxSize);

    if (invalidFiles.length > 0) {
      alert(
        `Os seguintes arquivos ultrapassam o limite de 10 MB:\n${invalidFiles
          .map((f) => f.name)
          .join("\n")}`
      );
      
      input.value = ""; // limpa o input
      this.files = null;
      return;
    }

    this.files = input.files;
  }

  uploadAll() {
    if (this.data.origin !== "manager") return this.uploadAttach();

    if (!this.files || this.files.length === 0) {
      alert("Selecione ao menos um arquivo antes de enviar.");
      return;
    }

    const path = this.router.url.substring("/files/view/".length);
    this.showLoading = true;

    from(Array.from(this.files))
      .pipe(
        concatMap((file) =>
          this.fileService
            .getPresignedUrl(file, path)
            .pipe(concatMap((response) => this.fileService.uploadFile(response.url, file)))
        )
      )
      .subscribe({
        complete: () => {
          this.dialogRef.close();
          this.showLoading = false;
          this.data.subject.next("file");
        },
        error: () => {
          this.showLoading = false;
          alert("Não foi possível enviar todos os arquivos selecionados.");
        },
      });
  }

  uploadAttach() {
    if (!this.files || this.files.length === 0) {
      alert("Selecione a planilha antes de enviar.");
      return;
    }

    this.showLoading = true;
    
    // Usa o novo endpoint que cria múltiplos pedidos
    const customerId = this.data.customerId;
    
    this.fileService.uploadOrdersFromFile(this.files[0], customerId).subscribe({
      next: (event) => {
        if (event.type === HttpEventType.Response) {
          this.dialogRef.close();
          this.showLoading = false;
          
          const response = event.body;
          
          // Retorna informações sobre os pedidos criados
          this.data.subject.next({
            success: response.success,
            fileUrl: response.fileUrl,
            ordersCreated: response.ordersCreated,
            orders: response.orders,
            message: response.message,
            errors: response.errors,
          });
        }
      },
      error: (err) => {
        console.error("Erro ao fazer upload:", err);
        this.showLoading = false;
        alert(
          (err && err.error && (err.error.error || err.error.message || err.error.details)) ||
            "Erro ao processar a planilha."
        );
      },
    });
  }

  cancel() {
    this.dialogRef.close();
  }
}
